import { TextField } from '@mui/material';
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers';
import { Control, Controller, FieldPath, FieldValues, RegisterOptions } from 'react-hook-form';

type OwnProps<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>> = {
    name: TName;
    control: Control<TFieldValues>;
    rules?: Omit<RegisterOptions<TFieldValues, TName>, 'valueAsNumber' | 'valueAsDate' | 'setValueAs'>;
} & Omit<DatePickerProps<Date, Date>, 'onChange' | 'value' | 'renderInput'>;

export function FormDatePicker<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>({
    name,
    label,
    rules,
    control,
    ...props
}: OwnProps<TFieldValues, TName>) {
    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            render={({ field: { value, ref, ...rest }, fieldState: { error } }) => (
                <DatePicker
                    label={label}
                    value={(value as Date) ?? null}
                    {...rest}
                    {...props}
                    ref={ref}
                    renderInput={params => (
                        <TextField
                            size="small"
                            variant="outlined"
                            helperText={error?.message}
                            {...params}
                            error={!!error}
                        />
                    )}
                />
            )}
        />
    );
}
